module.exports = __webpack_public_path__ + "static/media/learning-1.fbb50a40.png";